(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var hero = document.querySelector(".work-detail-hero");
    if (!hero) {
      return;
    }

    var titleNodes = document.querySelectorAll(
      ".work-detail-hero__title, .work-detail-next__title"
    );
    titleNodes.forEach(function (node) {
      var original = node.getAttribute("data-original-text") || node.textContent;
      if (!original) {
        return;
      }
      node.setAttribute("data-original-text", original);
      node.textContent = original.toLocaleUpperCase("tr-TR");
    });

    if (window.gsap && typeof window.DNB.revealText === "function") {
      var heroTitle = hero.querySelector(".work-detail-hero__title");
      var heroSubtitle = hero.querySelector(".work-detail-hero__subtitle");
      var heroTargets = [];
      if (heroTitle) {
        heroTargets.push(heroTitle);
      }
      if (heroSubtitle) {
        heroTargets.push(heroSubtitle);
      }

      if (heroTargets.length && hero.dataset.heroRevealReady !== "true") {
        hero.dataset.heroRevealReady = "true";
        window.DNB.revealText(heroTargets, {
          stagger: 0.16,
          duration: 0.9,
          ease: "expo.out",
          delay: 0.05
        });
      }
    }

    var overviewBody = document.querySelector(".work-detail-overview__body");
    if (overviewBody && window.matchMedia) {
      var toggleLabelCollapsed = "View Full Story";
      var toggleLabelExpanded = "Show less";
      var toggleIconSrc = "/assets/images/caret-circle-down.svg";
      var collapseHeight = 200;
      var mediaQuery = window.matchMedia("(max-width: 640px)");
      var toggleButton = null;
      var toggleIcon = null;
      var toggleLabel = null;

      var ensureToggleButton = function () {
        if (toggleButton) {
          return toggleButton;
        }
        toggleButton = document.createElement("button");
        toggleButton.type = "button";
        toggleButton.className = "work-detail-overview__toggle";
        toggleButton.setAttribute("aria-expanded", "false");

        toggleIcon = document.createElement("img");
        toggleIcon.className = "work-detail-overview__toggle-icon";
        toggleIcon.src = toggleIconSrc;
        toggleIcon.alt = "";
        toggleIcon.setAttribute("aria-hidden", "true");

        toggleLabel = document.createElement("span");
        toggleLabel.className = "work-detail-overview__toggle-label";
        toggleLabel.textContent = toggleLabelCollapsed;

        toggleButton.appendChild(toggleIcon);
        toggleButton.appendChild(toggleLabel);
        toggleButton.addEventListener("click", function () {
          var isExpanded = overviewBody.classList.contains("is-expanded");
          applyToggleState(!isExpanded);
        });

        overviewBody.insertAdjacentElement("afterend", toggleButton);
        return toggleButton;
      };

      var removeToggleButton = function () {
        if (!toggleButton) {
          return;
        }
        toggleButton.remove();
        toggleButton = null;
        toggleIcon = null;
        toggleLabel = null;
      };

      var applyToggleState = function (isExpanded) {
        overviewBody.classList.toggle("is-expanded", isExpanded);
        overviewBody.classList.toggle("is-collapsed", !isExpanded);
        if (!toggleButton) {
          return;
        }
        toggleButton.classList.toggle("is-expanded", isExpanded);
        toggleButton.setAttribute("aria-expanded", isExpanded ? "true" : "false");
        if (toggleLabel) {
          toggleLabel.textContent = isExpanded ? toggleLabelExpanded : toggleLabelCollapsed;
        }
      };

      var updateToggleState = function () {
        if (!mediaQuery.matches) {
          overviewBody.classList.remove("is-collapsed", "is-expanded");
          removeToggleButton();
          return;
        }

        var wasExpanded = overviewBody.classList.contains("is-expanded");
        overviewBody.classList.remove("is-collapsed", "is-expanded");

        var shouldCollapse = overviewBody.scrollHeight > collapseHeight;
        if (!shouldCollapse) {
          removeToggleButton();
          return;
        }

        ensureToggleButton();
        applyToggleState(wasExpanded);
      };

      updateToggleState();
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener("change", updateToggleState);
      } else if (mediaQuery.addListener) {
        mediaQuery.addListener(updateToggleState);
      }
      window.addEventListener("load", updateToggleState);
    }

    const video = document.querySelector(".work-detail-hero__video");
    const header = document.querySelector(".site-header");

    if (video && header) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d", { willReadFrequently: true });

      let samplingInterval = null;
      let initialCheckInterval = null;
      let initialChecksStarted = false;
      let initialAttempts = 0;
      let hasApplied = false;

      function stopSampling() {
        if (samplingInterval) {
          clearInterval(samplingInterval);
          samplingInterval = null;
        }
      }

      function stopInitialChecks() {
        if (initialCheckInterval) {
          clearInterval(initialCheckInterval);
          initialCheckInterval = null;
        }
      }

      video.addEventListener("play", () => {
        if (hasApplied) {
          return;
        }
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        stopSampling();
        samplingInterval = setInterval(sampleColor, 250); // 4 fps yeterli
      });

      video.addEventListener("pause", () => {
        stopSampling();
      });

      function startInitialChecks() {
        if (initialChecksStarted || hasApplied) {
          return;
        }
        initialChecksStarted = true;
        initialCheckInterval = setInterval(function () {
          initialAttempts += 1;
          sampleColor();
          if (hasApplied || initialAttempts >= 5) {
            stopInitialChecks();
          }
        }, 1000);
      }

      function sampleColor() {
        if (hasApplied || video.ended) return;
        if (video.readyState < 2) return;

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // ekranın sağ üstüne denk gelen video koordinatı
      const sampleX = canvas.width - 40;
      const sampleY = 40;
      const sampleSize = 40;

      const imageData = ctx.getImageData(sampleX, sampleY, sampleSize, sampleSize);
      const data = imageData.data;

      let r = 0, g = 0, b = 0;
      const count = data.length / 4;

      for (let i = 0; i < data.length; i += 4) {
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
      }

      r /= count;
      g /= count;
      b /= count;

        if (isBlueCyanRange(r, g, b)) {
          header.classList.add("is-blue-bg");
          hasApplied = true;
          stopSampling();
          stopInitialChecks();
        } else {
          header.classList.remove("is-blue-bg");
        }
      }

      video.addEventListener("loadeddata", startInitialChecks);
      video.addEventListener("canplay", startInitialChecks);
      if (video.readyState >= 2) {
        startInitialChecks();
      }
    }

    function isBlueCyanRange(r, g, b) {
      // normalize
      r /= 255;
      g /= 255;
      b /= 255;

      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      const delta = max - min;

      let hue = 0;

      if (delta !== 0) {
        if (max === b) hue = 60 * (((r - g) / delta) + 4);
        else if (max === g) hue = 60 * (((b - r) / delta) + 2);
        else hue = 60 * (((g - b) / delta));
      }

      // cyan/turkuaz tonlari daha kolay yakalansin
      return hue >= 160 && hue <= 205;
    }


    var slider = document.querySelector("[data-work-detail-slider]");
    if (slider && window.Swiper) {
      var swiperOptions = {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 30,
        loop: true,
        grabCursor: true,
        speed: 700,
        initialSlide: 0,
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          640: {
            slidesPerView: 1.6,
            spaceBetween: 20
          },
          900: {
            slidesPerView: 2.2,
            spaceBetween: 24
          },
          1200: {
            slidesPerView: 3.2,
            spaceBetween: 30
          },
          1640: {
            slidesPerView: 4.8,
            spaceBetween: 30
          }
        }
      };

      var normalizeSlidesValue = function (value) {
        return typeof value === "number" && !isNaN(value) ? value : 1;
      };

      var getMaxSlidesPerView = function (options) {
        var maxValue = normalizeSlidesValue(options.slidesPerView);
        var breakpoints = options.breakpoints || {};
        Object.keys(breakpoints).forEach(function (key) {
          var entry = breakpoints[key];
          if (entry && typeof entry.slidesPerView !== "undefined") {
            var nextValue = normalizeSlidesValue(entry.slidesPerView);
            if (nextValue > maxValue) {
              maxValue = nextValue;
            }
          }
        });
        return maxValue;
      };

      var getMaxSlidesPerGroup = function (options) {
        var maxValue = normalizeSlidesValue(options.slidesPerGroup || 1);
        var breakpoints = options.breakpoints || {};
        Object.keys(breakpoints).forEach(function (key) {
          var entry = breakpoints[key];
          if (entry && typeof entry.slidesPerGroup !== "undefined") {
            var nextValue = normalizeSlidesValue(entry.slidesPerGroup);
            if (nextValue > maxValue) {
              maxValue = nextValue;
            }
          }
        });
        return maxValue;
      };

      var ensureLoopSlides = function (root, options) {
        if (!root || !options || !options.loop) {
          return;
        }
        var wrapper = root.querySelector(".swiper-wrapper");
        if (!wrapper) {
          return;
        }
        var slides = Array.prototype.slice.call(wrapper.children);
        if (!slides.length) {
          return;
        }
        var required =
          Math.ceil(getMaxSlidesPerView(options)) + getMaxSlidesPerGroup(options);
        if (!required || slides.length >= required) {
          return;
        }
        var missing = required - slides.length;
        for (var i = 0; i < missing; i += 1) {
          var clone = slides[i % slides.length].cloneNode(true);
          clone.classList.add("swiper-slide--clone");
          wrapper.appendChild(clone);
        }
      };

      ensureLoopSlides(slider, swiperOptions);

      new window.Swiper(slider, swiperOptions);
    }

    var lottieTarget = document.querySelector("[data-lottie-arrow]");
    if (lottieTarget && (window.lottie || window.bodymovin)) {
      var lottiePlayer = window.lottie || window.bodymovin;
      var prefersReducedMotion =
        window.DNB && window.DNB.prefersReducedMotion ? true : false;

      lottieTarget.textContent = "";

      var animation = lottiePlayer.loadAnimation({
        container: lottieTarget,
        renderer: "svg",
        loop: !prefersReducedMotion,
        autoplay: !prefersReducedMotion,
        path: "/assets/lottie/arrow_anim_lottie.json",
        rendererSettings: {
          preserveAspectRatio: "xMidYMid meet"
        }
      });

      if (prefersReducedMotion && animation && animation.goToAndStop) {
        animation.goToAndStop(0, true);
      }
    }
  });
})();
